import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import { M } from '@dashboard-experience/mastodon';
import 'scss/CandidateStories.scss';
import { PromptItem, PromptDocuments } from 'types/candidateStories';
import FilePromptUploadSection from './FilePromptUploadSection';
import { findItemTranslation } from '../../../../../../../../helpers';
import ExampleList from '../../ExampleList';

const FilePromptItem = ({
  item,
  promptDocuments,
  remove,
  recordId,
}: {
  item: PromptItem;
  promptDocuments: PromptDocuments;
  remove: (index: number, field: string) => void;
  recordId?: string;
}) => {
  const currentLanguage = i18n.getLocale();
  const translatedItem = findItemTranslation(item, currentLanguage);

  const exampleKeyBase =
    'components.Report.CandidateStories.Modal.UploadDocuments';
  const exampleKeys = [
    'example1',
    'example2',
    'example3',
    'example4',
    'example5',
    'example6',
  ].map(key => `${exampleKeyBase}.${key}`);

  const field = recordId
    ? `candidateStories.promptGroup.${recordId}.${item.id}.documents`
    : `candidateStories.promptGroup.general.${item.id}.documents`;

  if (!promptDocuments[item.id]?.documents) {
    promptDocuments[item.id] = { documents: [] };
  }

  const removeDocuments = (index: number) => {
    remove(index, field);
  };

  return (
    <div
      key={item.id}
      data-testid={`file-prompt-item-${item.id}`}
      className='mb-4'
    >
      <div className='d-flex'>
        <div className='mr-2 cans-upload-icon-container'>
          <M.Icon name='DocumentAdd' size='lg' />
        </div>
        <div>
          <div className='h6 mt-2 mb-2'>
            {translatedItem?.title}
            {item.required && <span className='text-danger'> *</span>}
          </div>
          <div className='mb-2'>
            {recordId ? (
              <p className='text-muted'>{translatedItem?.description}</p>
            ) : (
              <ExampleList exampleKeys={exampleKeys} />
            )}
            <FilePromptUploadSection
              item={item}
              documents={promptDocuments[item.id].documents}
              onRemove={removeDocuments}
              field={field}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilePromptItem;
